import { FLAG_NAMES } from "../flag-constants";
import { SettingsConfig } from "../settings-type";

const tourSettings: Partial<SettingsConfig> = {
  [FLAG_NAMES.DATADOG_RUM_ENABLED]: true,
};

export default tourSettings;
